<div
  class="header-cell dropdown"
  [ngClass]="{ 'text-right': column.alignToRight }"
  bsDropdown
  [insideClick]="true"
  [isOpen]="isOpen"
  (isOpenChange)="onDropdownOpen($event)"
>
  <span *ngIf="!column.canSort && !column.canFilter">
    {{ column.title }}
  </span>
  <span
    class="clickable d-flex align-items-center"
    *ngIf="column.canSort && !column.canFilter"
    (click)="onSortBy(column.name)"
  >
    <span class="mr-1 title" [ngClass]="{ 'text-black': sortBy === column.name }">{{ column.title }}</span>
    <i
      class="icon icon-table-sort-a-z"
      [ngClass]="{
        'icon-rotate-180': sortBy === column.name && sortDirection === sortDirections.Descending,
        'text-black': sortBy === column.name
      }"
    ></i>
  </span>
  <span class="clickable d-flex align-items-center" *ngIf="column.canFilter" dropdownToggle>
    <span class="mr-1 title" [ngClass]="{ 'text-black': sortBy === column.name || filterValue.length > 0 }">{{
      column.title
    }}</span>
    <i
      class="icon icon-table-sort-a-z mr-1"
      *ngIf="column.canSort"
      [ngClass]="{
        'icon-rotate-180': sortBy === column.name && sortDirection === sortDirections.Descending,
        'text-black': sortBy === column.name
      }"
    ></i>
    <i class="icon icon-filtered-not-active" [ngClass]="{ 'text-black': filterValue.length > 0 }"></i>
  </span>
  <div *dropdownMenu class="dropdown-menu" role="menu" (click)="$event.stopPropagation()">
    <gcc-grid-sorting
      *ngIf="column.canSort"
      [column]="column"
      [isActive]="columnValue.sortBy === column.name"
      [sortDirection]="columnValue.sortDirection"
      (sortChange)="onSort($event)"
    ></gcc-grid-sorting>

    <li *ngIf="column.canSort" class="dropdown-divider mx-3"></li>
    <div>
      <template #filterContainer></template>
    </div>
    <div class="dropdown-menu__footer mb-n2 py-3 px-4 d-flex justify-content-between">
      <button *ngIf="filterValue?.length" type="button" class="btn btn-link btn-sm ml-n2" (click)="onReset()">
        Reset
      </button>
      <div class="flex-grow-1 text-right">
        <button type="button" class="btn btn-light btn-sm mr-2" (click)="onCancel()">Cancel</button>
        <button type="button" class="btn btn-primary btn-sm" (click)="onApply()">Apply</button>
      </div>
    </div>
  </div>
</div>
